import React from 'react';
import * as $ from 'jquery';
import useHttp from '../../../../../hook/use-http';
import { useState, useRef, useEffect } from 'react';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { INIT_STATE_SELECTS, INDEX } from "../../../../../constants/driveglobalfilterinitalstates_bus";
import CustomSelect_Bus from './CustomSelect_Bus';
import { BsFillSkipBackwardBtnFill } from "react-icons/bs";
import { API_URL_MAIN } from '../../../../../constants/driveglobalfilterinitalstates_bus';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCityDepo } from '../../../../../redux/cityDepoSlice';
import styles from './Filter_Bus.module.css'
import "./styles.css"

export default function BDT_Filter(props) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [filterdata, setFilterData] = useState({ ...props.gloablfilter });
  const inputRef = useRef(null);

  const formatDateForDisplay = (date) => {
    return date ? moment(date).format('MMM D, YYYY') : '';
  };

  useEffect(() => {
    if (filterdata.startDate) {
      const today = moment();
      const fiveYearsAgo = moment().subtract(5, 'years');
      const defaultStart = moment(filterdata.startDate);
      const defaultEnd = moment(filterdata.endDate);

      $(inputRef.current).daterangepicker(
        {
          startDate: defaultStart,
          endDate: defaultEnd,
          minDate: fiveYearsAgo,
          maxDate: today,
          showDropdowns: true,
          autoUpdateInput: false,
          singleMonthMode: true,
          linkedCalendars: false,
          locale: {
            format: 'MMMM D, YYYY',
            applyLabel: 'Apply',
            separator: ' - ',
            cancelLabel: '',
          },
        }
      );

      // Handle 'Apply' button click
      $(inputRef.current).on('show.daterangepicker', function (ev, picker) {
        picker.container.addClass('ms_ace');
      });

      $(inputRef.current).on('apply.daterangepicker', function (ev, picker) {
        const start = picker.startDate.format("YYYY-MM-DD");
        const end = picker.endDate.format("YYYY-MM-DD");

        $(this).val(
          picker.startDate.format('MMMM D, YYYY') + ' - ' + picker.endDate.format('MMMM D, YYYY')
        );

        setFilterData(prev => ({
          ...prev,
          startDate: start,
          endDate: end,
        }));
        props.onsubmit(prev => ({
          ...prev,
          startDate: start,
          endDate: end,
        }));
      });

      $(inputRef.current).on('cancel.daterangepicker', function () {
        $(this).val('');
        setFilterData(prev => ({
          ...prev,
          startDate: null,
          endDate: null,
        }));
      });
    }

    return () => {
      if ($(inputRef.current).data('daterangepicker')) {
        $(inputRef.current).data('daterangepicker').remove();
        $(inputRef.current).off('.daterangepicker');
      }
    };
  }, []);

  return (
    <>
      <div className="card mb-3 p-3">
        <div className="row">

          {/* Date Range */}
          <div className="col-md-3">
            <div className={`mb-1 ${styles.date_range_selection}`} style={{ textAlign: 'left' }}>Date Range</div>
            <div className="input-group mt-1">
              <input
                type="text"
                ref={inputRef}
                className={`form-control ${styles.customDateRangePicker}`}
                placeholder="Select date range"
                value={
                  filterdata.startDate && filterdata.endDate
                    ? `${formatDateForDisplay(filterdata.startDate)} - ${formatDateForDisplay(filterdata.endDate)}`
                    : ''
                }
                readOnly
              />
            </div>
          </div>

          {/*  Commented filters not needed in Mileage Saarathi Tab */}
          {/*
          <div className="col-md-3">
            <div className={`mb-1 ${styles.date_range_selection}`}>Select City</div>
            <CustomSelect_Bus setGlobalFilter={props.setGlobalFilter}></CustomSelect_Bus>
          </div>
 
          <div className="col-md-3">
            <div className={`mb-1 ${styles.date_range_selection}`}>Select Up/Down Route</div>
            <select className="form-select">
              <option value="">Select Up/Down</option>
              <option value="up">Up</option>
              <option value="down">Down</option>
            </select>
          </div>
 
          <div className="col-md-3">
            <div className={`mb-1 ${styles.date_range_selection}`}>Select Route</div>
            <select className="form-select">
              <option value="">Select Route</option>
              <option value="route1">Route 1</option>
              <option value="route2">Route 2</option>
            </select>
          </div>
          */}
        </div>
      </div>
    </>
  )
}
